import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LogFonctionnelService, ActionEnum, ResultEnum, TypeTargetEnum } from '../log-fonctionnel/log-fonctionnel.service';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { ApiCryptMailMessage, ApiCryptMailMessagePjData } from 'src/app/utils/interfaces/new/apicrypt-mail';
import { IdentifiantsTemporairesConnexion } from 'src/app/utils/interfaces/new/identifiantsTemporairesConnexion';
import { EmailAuthent } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { MSSFolderValidate } from 'src/app/utils/interfaces/new/mss-folder-validate.interface';
import { MSSFolder } from 'src/app/utils/interfaces/new/mss-folder.interface';
import { MSSMessageValidate } from 'src/app/utils/interfaces/new/mss-message-validate.interface';
import { MSSAddress, MSSAttachment, MSSAttachmentResponse, MSSEnumFlag, MSSEnumTypeMail, MSSMessage, MSSMessageToSend } from 'src/app/utils/interfaces/new/mss-message.interface';
import { MSSFullTextSearchCriteria, MSSSearchCriteria } from 'src/app/utils/interfaces/new/mss-search-criteria.interface';
import { MSSSyncMessagesResponse } from 'src/app/utils/interfaces/new/mss-sync-messages-response.interface';
import { PractitionerSearchResult } from 'src/app/utils/interfaces/new/PractitionerSearchResult';
import { PractitionerSearchResultApi } from 'src/app/utils/interfaces/new/PractitionerSearchResultApi';
import { environment } from 'src/environments/environment';
import { AnnuaireProfessionnelsSanteService } from '../annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { FiltresService } from '../filtres/filtres.service';
import { RessourceService } from '../ressource/ressource.service';
import { MssServiceAbstract, PractitionerSearchParams, PractitionerSearchParamsAPICRYPT } from './mss-service.abstract';



const MSS_PATHS = {
  listKeys: 'listKeys',
  selectKey: 'selectKey',
  listMails: 'list',
  pjDownload: 'pj/download',
  messageAck: 'message/ack',
  isSessionValid: 'session/is-valid',
};


@Injectable({
  providedIn: 'root'
})
export class MssApicryptService extends MssServiceAbstract {

  private httpOptions = {
    observe: 'response' as 'response',
    headers: new HttpHeaders(),
    params: undefined
  };
  private _lastMessages: Array<MSSMessage>;

  doitReleverMessageLu: boolean = false; // infos inexistante dans apicrypt à supprimer
  doitSupprimerApresRelevage: boolean = false;

  constructor(
    protected _http: HttpClient,
    private _resourceSrv: RessourceService,
    private _apsService: AnnuaireProfessionnelsSanteService,
    protected _filtreSrv: FiltresService,
    protected _logSrv: LogFonctionnelService
  ) {
    super(_http, _filtreSrv, _logSrv);
  }

  private _getBasePath(domain: 'certsKeys' | 'mail'): string {
    if (domain === 'certsKeys') {
      return `${environment.compagnonCpsBasePath}/${environment.compagnonCpsApicryptServicePath}/${environment.compagnonCpsApicryptServiceCertsKeysPath}`;
    } else if (domain === 'mail') {
      return `${environment.compagnonCpsBasePath}/${environment.compagnonCpsApicryptServicePath}/${environment.compagnonCpsApicryptServiceMailPath}`;
    }
  }

  listFolders(email: EmailAuthent, folderId?: number): Promise<MSSFolder[]> {
    throw new Error('Method listFolders not implemented.');
  }

  createFolder(email: EmailAuthent, folderName: string, folderParentId: number): Promise<MSSFolderValidate> {
    throw new Error('Method createFolder not implemented.');
  }

  trashFolder(email: EmailAuthent, folderId: number): Promise<void> {
    throw new Error('Method trashFolder not implemented.');
  }
  renameFolder(email: EmailAuthent, folderId: number, newFolderName: string): Promise<void> {
    throw new Error('Method renameFolder not implemented.');
  }

  private apiCryptMailMessageToMSSMessage(apiCryptMess: ApiCryptMailMessage): MSSMessage {
    const attachments: Array<MSSAttachmentResponse> = [];
    if (apiCryptMess.pjList) {
      apiCryptMess.pjList = apiCryptMess.pjList.filter(rPj => {
          const fileName = this.decodeBase64ToUtf8(rPj.name);
          if (!fileName.includes('.cwm') && !fileName.includes('PeriCollect') && !fileName.includes('apiv2sign')) {
              attachments.push({
                  contentType: rPj.mimeType,
                  fileName: fileName,
                  size: rPj.length,
                  part: Number(rPj.id),
                  file: rPj.data
              });
              return true; // Conserver dans pjList
          }
          return false; // Supprimer de pjList
      });
    }

    const addresses: Array<MSSAddress> = [];
    for (const rTo of apiCryptMess.to) {
      addresses.push({
        email: rTo,
        type: MSSEnumTypeMail.TO,
        name: rTo.split('@')[0]
      });
    }
    addresses.push({ email: apiCryptMess.from, type: MSSEnumTypeMail.FROM, name: apiCryptMess.from.split('@')[0] });

    const flags: Array<MSSEnumFlag> = [];
    if (apiCryptMess.state === 0) {
      flags.push(MSSEnumFlag.UNREAD);
    }

    if (apiCryptMess.pjList && apiCryptMess.pjList.length > 0) {
      flags.push(MSSEnumFlag.ATTACHMENT);
    }

    return {
      date: moment(apiCryptMess.date, 'DD/MM/YYYY HH:mm:ss').toDate(),
      folderId: 0,
      messageId: Number(apiCryptMess.id),
      size: apiCryptMess.size,
      subject: this.decodeBase64ToUtf8(apiCryptMess.subject),
      addresses,
      attachments,
      body: this.decodeBase64ToUtf8(apiCryptMess.body),
      flags,
      fragment: undefined,
      isBodyLarger: false,
      technicalId: apiCryptMess.messageId, // ID Technique chez eux (MessageID)
      origId: 0,
    };
  }

  private decodeBase64ToUtf8(base64String) {
    // Décoder la chaîne Base64 en ASCII
    const decodedAscii = atob(base64String);
    // Convertir en tableau de code UTF-8
    const utf8Array = new Uint8Array([...decodedAscii].map(char => char.charCodeAt(0)));
    // Utiliser TextDecoder pour convertir en chaîne UTF-8
    const utf8Decoder = new TextDecoder("utf-8");
    return utf8Decoder.decode(utf8Array);
  }

  async searchMessages(email: EmailAuthent, searchCriteria: MSSSearchCriteria, getcompletmessage = false): Promise<MSSMessage[]> {
    return new Promise<Array<MSSMessage>>(async (resolve, reject) => {
      try {
        const options = {...this.httpOptions};

        let params = new HttpParams();
        params = params.append('getcompletmessage', '0');

        options.params = params;

        const result = await this._http.get<Array<ApiCryptMailMessage> | Array<string>>(
          `${this._getBasePath('mail')}/${MSS_PATHS.listMails}`,
          options
        ).toPromise();


        if (result && result.body && result.body.length > 0) {
          const rtd: Array<MSSMessage> = [];

          // Option de relevage des messages
          // Grosso modo si on veut les messages complet ou pas :
          // getcompletmessage === true -> cas de recherche pour la boite de reception
          // getcompletmessage === false -> cas de recherche pour le relevage de messages
          if (getcompletmessage) {
            /**
             * Gestion du cas APICrypt Specifique pour la recherche de courier complet....
             * @param message
             */
            const _handleAndMarkAsRead = async (message: MSSMessage) => {
              // Recupération des pièces jointes
              try {
                await this.markMessageAsRead(email, message.messageId, message.technicalId);
              } catch (e) {
                console.log('Error while downloading attachments', e);
              }
            };

            const messageNumbers = result.body as Array<string>;

            if (this.canGetMessage()) {

              for (const messageId of messageNumbers) {
                const message = await this.getMessageById(email, messageId);
                if (!message) {
                  continue;
                }
                await _handleAndMarkAsRead(message);

                rtd.push(message);
              }
            }
          } else {
            resolve((result.body as Array<string>).map(m => {
              return {
                messageId: parseInt(m)
              } as MSSMessage;
            }));
          }
          this._addLog({ action: ActionEnum.Read, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Recherche/Relève messages Apicrypt', details: `GET ${MSS_PATHS.listMails}` });
        } else {
          reject('Pas de messages');
        }
      } catch (e) {
        this._addLog({ action: ActionEnum.Read, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Recherche/Relève messages Apicrypt', details: `GET ${MSS_PATHS.listMails} - Erreur: ${e?.error?.message || e?.message || 'Erreur inconnue'}` });
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  moveMessages(email: EmailAuthent, messageIds: number[], destinationFolderId: number): Promise<void> {
    throw new Error('Method moveMessages not implemented.');
  }
  syncMessages(email: EmailAuthent, folderId?: number, syncToken?: string): Promise<MSSSyncMessagesResponse> {
    throw new Error('Method syncMessages not implemented.');
  }
  async downloadAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<{file: File, base64: string}> {
    const base64toFile = async (base64: string, filename: string, mimeType: string): Promise<File> => {
      if (!base64.includes(`data:${mimeType};base64,`)) {
        base64 = `data:${mimeType};base64,${base64}`;
      }

      return new Promise<File>((resolve) => {
        fetch(base64).then((res) => {
          return res.arrayBuffer();
        }).then((buf) => {
          resolve(new File([buf], filename, { type: mimeType }));
        });
      });
    };

    return new Promise<{file: File, base64: string}>(async (resolve, reject) => {
      try {
        if (attachment.file) {
          /** On a déjà la base 64 en APICrypt donc normalement pas besoin de la redemander (Demande APICrypt) */
          const rtd: File = await base64toFile(attachment.file, attachment.fileName, attachment.contentType);
          resolve({
            file: rtd,
            base64: attachment.file
          });
        } else {
          let params = new HttpParams();
          params = params.append('id', messageId.toString());
          params = params.append('pjId', attachment.part.toString());
          const options = {...this.httpOptions};
          options.params = params;

          const result = await this._http.get<ApiCryptMailMessagePjData>(
            `${this._getBasePath('mail')}/${MSS_PATHS.pjDownload}`,
            options,
          ).toPromise();

          const rtd: File = await base64toFile(result.body.data, attachment.fileName, attachment.contentType);

          resolve({
            file: rtd,
            base64: result.body.data
          });
        }
      } catch (e) {
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  removeAttachment(email: EmailAuthent, messageId: number, attachment: MSSAttachment): Promise<void> {
    throw new Error('Method removeAttachment not implemented.');
  }
  async deleteMessage(email: EmailAuthent, messageId: number | number[]): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let params = new HttpParams();
        params = params.append('messageId', messageId.toString());
        const options = {...this.httpOptions};
        options.params = params;
        await this._http.delete<void>(
          `${this._getBasePath('mail')}/message`,
          options
          ).toPromise();
        resolve();
        this._addLog({ action: ActionEnum.Delete, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Suppression messages Apicrypt', details: `DELETE /message (IDs: ${Array.isArray(messageId) ? messageId.join(',') : messageId})` });
      } catch (e) {
        this._addLog({ action: ActionEnum.Delete, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Suppression messages Apicrypt', details: `DELETE /message - Erreur: ${e?.error?.message || e?.message || 'Erreur inconnue'}` });
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  draftMessage(email: EmailAuthent, messages: MSSMessageToSend): Promise<MSSMessageValidate> {
    throw new Error('Method draftMessage not implemented.');
  }
  async sendMessage(email: EmailAuthent, messages: MSSMessageToSend): Promise<MSSMessageValidate> {
    // Ajout de l'entete HPRIM APICRYPT ET DU FIN DE FICHIER APRES BODY

    let headerHprim = '';
    const CRLF = '\r\n';

    if(messages.patientInfo) { //CREATION ENTETE HPRIM 12 Lignes
      // edition des 12 ligne  d'entete HPRIM APICRYPT
      const adresses = messages.messageData.addresses;
      // Filtrer pour obtenir l'adresse avec type "FROM"
      const fromAddress = adresses.find(address => address.type === 'FROM');
      let adresseExpediteur = '';
      if (fromAddress && fromAddress.email.includes('@')) {
        // Extraire la partie avant le "@"
        adresseExpediteur = fromAddress.email.split('@')[0];
      }else{
        adresseExpediteur = fromAddress.email;
      }
      const ToAddress = adresses.find(address => address.type === 'TO');
      let adresseDestinataire = '';
      if (ToAddress && ToAddress.email.includes('@')) {
        // Extraire la partie avant le "@"
        adresseDestinataire = ToAddress.email.split('@')[0];
      }else{
        adresseExpediteur = ToAddress.email;
      }

      const [year, month, day] = messages.patientInfo.birthDate.split('-');
      const formattedBirthDate = `${day}/${month}/${year}`;
      const formattedDayDate = new Date().toLocaleDateString('fr-FR')
      headerHprim+=CRLF //codepatient
      headerHprim+=messages.patientInfo.lastName+CRLF //Nom Patient
      headerHprim+=messages.patientInfo.firstName+CRLF //Prenom Patient
      headerHprim+=CRLF //ligne adr1
      headerHprim+=CRLF //ligne adr2
      headerHprim+=CRLF //codepostal-separateur espace-ville
      headerHprim+=formattedBirthDate+CRLF //Date de naissance JJ/MM/AAAA
      headerHprim+=CRLF //numSS
      headerHprim+=CRLF //numDossier
      headerHprim+=formattedDayDate+CRLF //Date dossier JJ/MM/AAAA (date du jour par defaut usage inconnu ^^)
      headerHprim+='.          '+adresseExpediteur+CRLF //10caractere debutant par un point + espace + NomApicrypt expéditeur
      headerHprim+='.          '+adresseDestinataire+CRLF //10caractere debutant par un point + espace + NomApicrypt Destinataire
    }

    let footerHprim = CRLF+"****FIN****"+CRLF+"****FINFICHIER****"

    const bodyToTexteBrut = (body: string): string => {
      try {
        // Fonction récursive pour parcourir les nœuds et récupérer le texte avec les sauts de ligne
        const getTextWithLineBreaks = (node: Node): string => {
          let text = '';
          for (let i = 0; i < node.childNodes.length; i++) {
            const childNode = node.childNodes[i];
            if (childNode.nodeType === Node.TEXT_NODE) {
              text += childNode.nodeValue;
            } else if (childNode.nodeType === Node.ELEMENT_NODE && childNode.nodeName !== 'SCRIPT' && childNode.nodeName !== 'STYLE') {
              text += getTextWithLineBreaks(childNode);
            }
          }
          if (node.nodeName === 'P' || node.nodeName === 'BR') {
            text += '\r\n'; // Ajouter un saut de ligne après les balises de paragraphe et de saut de ligne
          }
          return text;
        };

        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(body, 'text/html');
        return getTextWithLineBreaks(parsedHtml.body);

      } catch (e) {
        return body;
      }
    }

    return new Promise<MSSMessageValidate>(async (resolve, reject) => {
      try {
        const cc: Array<string> = [];
        const bcc: Array<string> = [];
        const to: Array<string> = [];
        let from = '';
        for (const a of messages.messageData.addresses) {
          switch (a.type) {
            case MSSEnumTypeMail.BCC:
              bcc.push(a.email);
              break;
            case MSSEnumTypeMail.CC:
              cc.push(a.email);
              break;
            case MSSEnumTypeMail.FROM:
              from = a.email;
              break;
            case MSSEnumTypeMail.TO:
              to.push(a.email);
              break;
          }
        }

        interface PJ {
          filename: string;
          data: string;
        }

        const pjList: Array<PJ> = [];
        for (const a of messages.messageData.attachments) {
          // API Crypt n'aime pas le prefixe data:XXXX/YYY;base64,
          // On le nettoie pour avoir juste la base 64
          const b64PrefixNeedle = ';base64,';
          if (a.file.includes(b64PrefixNeedle)) {
            a.file = a.file.split(b64PrefixNeedle)[1];
          }

          const MAX_APICRYPT_SIZE = 3 * 1024 * 1024; // 3 Mo
          const padding = (a.file.match(/=/g) || []).length;
          const sizeInBytes = (a.file.length * 3 / 4) - padding;

          if (sizeInBytes > MAX_APICRYPT_SIZE) {
            throw new Error(`La pièce jointe "${a.fileName}" dépasse la taille maximale de 3 Mo autorisée par Apicrypt.`);
          }

          pjList.push({
            data: a.file,
            filename: a.fileName
          });
        }

        const body: any = {
          to,
          subject: messages.messageData.subject,
          content: headerHprim+bodyToTexteBrut(messages.messageData.body)+footerHprim,
          pjList,
          cc,
          bcc,
          from,
        };

        await this._http.post<void>(
          `${this._getBasePath('mail')}/message`,
          body,
          this.httpOptions
        ).toPromise();
        resolve(undefined);
        this._addLog({ action: ActionEnum.Create, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Envoi message Apicrypt', details: `POST /message` });
      } catch (e) {
        this._addLog({ action: ActionEnum.Create, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Envoi message Apicrypt', details: `POST /message - Erreur: ${e?.error?.message || e?.message || 'Erreur inconnue'}` });
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  async markMessageAsRead(email: EmailAuthent, _: number | number[], technicalId?: string | string[]): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        /**
         * Dans apicrypt pour pouvoir ack un message il faut l'ID Technique (MessageID chez eux ><)
         * on prend donc cet elemnt plutot que messageId qu'on stoque habituellement
         */
        const techIdParams = Array.isArray(technicalId) ? technicalId : [technicalId];
        for (let i = 0; i < techIdParams.length; i++) {
          if (techIdParams[i]) {
            await this._markMessageAsRead(email, techIdParams[i], this.doitSupprimerApresRelevage);
          } else {
            throw new Error('Technical ID is missing');
          }
        }
        resolve();
      } catch (e) {
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  private async _markMessageAsRead(email: EmailAuthent, messageId: string, deleteAfter: boolean): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let params = new HttpParams();
        params = params.append('messageId', messageId);
        params = params.append('deleteAfterAck', deleteAfter.toString());
        const options = {...this.httpOptions};
        options.params = params;
        await this._http.put<void>(
          `${this._getBasePath('mail')}/${MSS_PATHS.messageAck}`,
          {},
          options
        ).toPromise();
        resolve();
      } catch (e) {
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
  async fullTextSearchMessages(email: EmailAuthent, searchCriteria: MSSFullTextSearchCriteria): Promise<MSSMessage[]> {
    if (!this._lastMessages || this._lastMessages.length < 1) {
      this._lastMessages = await this.searchMessages(undefined, undefined);
    }

    const rtd: Array<MSSMessage> = [];

    if (searchCriteria && searchCriteria.query && searchCriteria.query.searchString) {
      for (const m of this._lastMessages)  {
        if (m.body && m.body.toLowerCase().includes(searchCriteria.query.searchString.toLowerCase())) {
          rtd.push(m);
        } else if (m.subject && m.subject.toLowerCase().includes(searchCriteria.query.searchString.toLowerCase())) {
          rtd.push(m);
        }
      }
    }

    return rtd;
  }
  async findMSSRecipient(params: PractitionerSearchParams,
                         limit: number, offset: number,
                         doForceSearch: boolean): Promise<PractitionerSearchResult> {
    return new Promise<PractitionerSearchResult>(async (resolve, reject) => {
      try {
        resolve(await this._apsService.searchProfessionals(params, limit, offset, doForceSearch));
      } catch (e) {
        reject(e);
      }
    });
  }

  async findMSSRecipientApi(params: PractitionerSearchParamsAPICRYPT,
                         limit: number, offset: number,
                         doForceSearch: boolean): Promise<PractitionerSearchResultApi> {
    return new Promise<PractitionerSearchResultApi>(async (resolve, reject) => {
      try {
        resolve(await this._apsService.searchProfessionalsApi(params, limit, offset, doForceSearch));
      } catch (e) {
        reject(e);
      }
    });
  }

  async connectToMSSByIDNAT(mail: string, password: string): Promise<any> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let params = new HttpParams();
        params = params.append('keyName', mail);
        params = params.append('keyPassword', password);
        const options = {...this.httpOptions};
        options.params = params;
        await this._http.post<void>(
          `${this._getBasePath('certsKeys')}/${MSS_PATHS.selectKey}`,
          {},
          options
        ).toPromise();
        resolve();
        this.authenticationErrorSubject.next(true);
        this._addLog({ action: ActionEnum.Read, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Connexion messagerie MSSanté', details: `POST ${MSS_PATHS.selectKey}` });
      } catch (e) {
        this._addLog({ action: ActionEnum.Read, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Connexion messagerie MSSanté', details: `POST ${MSS_PATHS.selectKey} - Erreur: ${e?.error?.error || e?.message || 'Erreur inconnue'}` });
        reject(e.error.error);
      }
    });
  }
  validateOTP(otp: string, identifiants: IdentifiantsTemporairesConnexion): Promise<void> {
    throw new Error('Method validateOTP not implemented.');
  }

  public storeToken(token: string, idNat: string): void {
    throw new Error('Method storeToken not implemented.');
  }

  clearToken(idNat: string): void {
    throw new Error('Method clearToken not implemented.');
  }
  async listAccounts(): Promise<string[]> {
    return new Promise<Array<string>>(async (resolve, reject) => {
      try {
        const rtd = await this._http.get<Array<string>>(
          `${this._getBasePath('certsKeys')}/${MSS_PATHS.listKeys}`,
          this.httpOptions
        ).toPromise();
        resolve(rtd.body);
      } catch (e) {
        reject(e);
      }
    });
  }

  canCreateFolders(): boolean {
    return false;
  }

  canRenameFolders(): boolean {
    return false;
  }

  canRemoveFolders(): boolean {
    return false;
  }

  canListFolders(): boolean {
    return false;
  }

  canMoveMessages(): boolean {
    return false;
  }
  canSyncMessages(): boolean {
    return false;
  }

  canRemoveAttachment(): boolean {
    return false;
  }

  canDraftMessage(): boolean {
    return false;
  }

  canMarkMessageAsRead(): boolean {
    return false;
  }

  isTokenNeeded(): boolean {
    return false;
  }

  isOTPNeeded(): boolean {
    return false;
  }

  isSearchMessageHandlePagination(): boolean {
    return false;
  }

  mustDraftToAddAttachment(): boolean {
    return false;
  }
  providerLibellePrefix(): string {
    return 'ApiCrypt';
  }

  isSessionValid(email: EmailAuthent): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      try {
        let params = new HttpParams();
        params = params.append('keyName', email.email);
        const options = {...this.httpOptions};
        options.params = params;
        const result = await this._http.get<boolean>(
          `${this._getBasePath('certsKeys')}/${MSS_PATHS.isSessionValid}`,
          options
        ).toPromise();
        resolve(result.body);
      } catch (e) {
        resolve(false);
      }
    });
  }

  canGetMessage(): boolean {
    return true;
  }

  getMessageById(email: EmailAuthent, messageId: string): Promise<MSSMessage | undefined> {
    return new Promise<MSSMessage>(async (resolve, reject) => {
      try {
        const options = {...this.httpOptions};

        let params = new HttpParams();
        params = params.append('id', messageId);
        options.params = params;

        const rtd = await this._http.get<ApiCryptMailMessage>(
          `${this._getBasePath('mail')}/message`,
          options
        ).toPromise();
        if (rtd && rtd.body) {
          // if (!this.doitReleverMessageLu && rtd.body.state === 0) {
          //   resolve(undefined);
          // } else {
          //   resolve(this.apiCryptMailMessageToMSSMessage(rtd.body));
          // }
          resolve(this.apiCryptMailMessageToMSSMessage(rtd.body));

        } else {
          resolve(undefined);
        }
        this._addLog({ action: ActionEnum.Read, result: ResultEnum.Success, typeTarget: TypeTargetEnum.NONE, subDomain: 'Lecture message APICRYPT', details: `GET /message (ID: ${messageId})` });
      } catch (e) {
        this._addLog({ action: ActionEnum.Read, result: ResultEnum.Error, typeTarget: TypeTargetEnum.NONE, subDomain: 'Lecture message APICRYPT', details: `GET /message (ID: ${messageId}) - Erreur: ${e?.error?.message || e?.message || 'Erreur inconnue'}` });
        if (!await this.isSessionValid(email)) {
          this.authenticationErrorSubject.next(false);
          reject();
        } else {
          reject(e);
        }
      }
    });
  }
}
